import { render, staticRenderFns } from "./ConventionInputForm.vue?vue&type=template&id=93d89276&"
import script from "./ConventionInputForm.vue?vue&type=script&lang=js&"
export * from "./ConventionInputForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93d89276')) {
      api.createRecord('93d89276', component.options)
    } else {
      api.reload('93d89276', component.options)
    }
    module.hot.accept("./ConventionInputForm.vue?vue&type=template&id=93d89276&", function () {
      api.rerender('93d89276', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/companies/60100003-2/views/ConventionInputForm.vue"
export default component.exports